import React, {PureComponent} from "react";
import axios from "axios";
import {authService} from "./auth";
import * as _ from "lodash";
import {convertUnicode} from "./commons/CommonFunctions";


export default class Promotion extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
            promotionData:[],
            localStorageData: authService.getUserDetailsFromLocalStorage(),

        }
    }
    getPromotion = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/backend/public/promotion/getPromotion/' + this.state.localStorageData.userId ,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.status === 200) {
                this.setState({
                    promotionData: response.data.body
                })
            }
        })
    }

    componentDidMount() {

        this.getPromotion()
    }
    continueInBrowser = () => {
        localStorage.setItem('appDownloaded', true);
        this.setState({disablebarMobileBrowser: true});
    }

    render() {
        return  <div className="bkappdownloadModal fordsktp">
            <button type="button" className="dnladclose" onClick={() => this.continueInBrowser()}><span
                aria-hidden="true">×</span></button>
            <div className="container">
                <div className="bkdwnldapp">
                    <img
                        src={this.state.promotionData && this.state.promotionData.coverImageUrl  ? 'https://cdn.dscovr.com/images/PhoneAppIMG.webp' : 'https://cdn.dscovr.com/images/PhoneAppIMG.webp'}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://cdn.dscovr.com/images/project-default.jpg"
                        }}
                        alt=""/>
                    <strong>{this.state.promotionData.title}</strong>

                </div>
            </div>
        </div>


    }
}
